import i18next from 'i18next'

i18next.addResourceBundle('en', 'common', {
    openl_studio: 'OpenL Studio',
    users: 'Users',
    groups: 'Groups',
    loading: 'Loading...',
    select_repository: 'Select Repository',
    select_role: 'Select Role',
    add_role: 'Add Role',
    role_t: 'Role',
    select_project: 'Select Project',
    deploy_repository: 'Deploy Repository',
    design_repository: 'Design Repository',
    project: 'Project',
    details: 'Details',
    none: 'None',
    login: 'Login',
    password: 'Password',
    access_rights: 'Access Rights',
    table: {
        showing_rows: '{{from}}-{{to}} of {{total}}',
    },
    help: {
        openl_tablets_help_title: 'Welcome to OpenL Tablets Help Center',
        openl_tablets_help_description: 'Here you can find documentation, guides, and resources to help you use OpenL Tablets effectively.',
        documentation: 'Documentation',
        on_the_internet: 'On the Internet',
        additional_information: 'Additional Information',
        support: 'Support',
    },
    menu: {
        editor: 'Editor',
        repository: 'Repository',
        projects: 'Projects',
        deployments: 'Deployments',
        my_profile: 'My Profile',
        my_settings: 'My Settings',
        personal_access_tokens: 'Personal Access Tokens',
        repositories: 'Repositories',
        system: 'System',
        security: 'Security',
        groups: 'Groups',
        users: 'Users',
        notification: 'Notification',
        tags: 'Tags',
        mail: 'Mail',
    },
    user_menu: {
        my_profile: 'My Profile',
        my_settings: 'My Settings',
        administration: 'Administration',
        help: 'Help',
        sign_out: 'Sign Out',
        version: 'Version: {{version}}',
    },
    btn: {
        ok: 'OK',
        save: 'Save',
        cancel: 'Cancel',
        apply: 'Apply',
        create: 'Create',
        invite: 'Invite',
    },
    confirm: {
        title: 'Confirm',
    },
    validation: {
        required: 'Required',
        invalid_email: 'Invalid email address',
        leave_blank: 'Leave blank to keep the current value'
    },
    role: {
        VIEWER: 'Viewer',
        CONTRIBUTOR: 'Contributor',
        MANAGER: 'Manager',
    },
    // Common error messages
    please_fix_errors_on_highlighted_tabs_before_saving: 'Please fix the errors before saving',
    error: 'Error',
    copy_failed: 'Failed to copy to clipboard',
})
